import { ForgotPasswordForm } from 'pages/authentication/forgot_password/components/ForgotPasswordForm';
import { LoginFooter } from 'pages/authentication/login';
import { useNavigate } from 'react-router-dom';
import { AuthApi } from 'apis/AuthApi';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

import 'pages/authentication/login/styles/Login.scss';

export const ForgotPassword = () => {

    const navigate = useNavigate();

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        error: '',
        loading: false,
        showSuccess: false,
        successMessage: ''
    });

    const { error, loading, showSuccess, successMessage } = state;

    const handleSubmit = async (email: string) => {

        try {

            setState({ error: '', loading: true });
            await AuthApi.ForgotPassword(email);
            setState({
                loading: false,
                showSuccess: true,
                successMessage: formatMessage({ id: 'if_this_email_address_corresponds_to_an.db914baf', defaultMessage: 'If this email address corresponds to an Admin account. An email with password reset instructions will be sent.' }) || 'If this email address corresponds to an Admin account. An email with password reset instructions will be sent.'
            });

        } catch {

            setState({ loading: false });

        }

    };

    const buildNumber = document.getElementById('root')?.dataset.build || '';

    return (
        <div className="login-page">
            <div className="login-form-panel d-flex flex-column position-relative bg-transparent">
                {showSuccess && (
                    <div className="login-success-banner w-100 mx-auto mb-3 d-flex align-items-start gap-3">
                        <i className="fa-solid fa-circle-check login-success-icon flex-shrink-0" />
                        <span className="login-success-body flex-grow-1">
                            {successMessage}
                        </span>
                        <button
                            className="login-success-dismiss"
                            onClick={() => setState({ showSuccess: false, successMessage: '' })}
                            type="button"
                        >
                            <i className="fa-solid fa-xmark" />
                        </button>
                    </div>
                )}

                {error && (
                    <div className="login-error-banner w-100 mx-auto mb-3 d-flex align-items-start gap-3">
                        <i className="fa-solid fa-circle-exclamation login-error-icon flex-shrink-0" />
                        <span className="login-error-body flex-grow-1">
                            {error}
                        </span>
                    </div>
                )}

                <div className="login-form-container d-flex flex-column align-items-center">
                    <div className="login-card w-100 bg-white">
                        <ForgotPasswordForm
                            loading={loading}
                            onBack={() => navigate('/login')}
                            onError={msg => setState({ error: msg })}
                            onSubmit={handleSubmit}
                        />
                    </div>
                </div>

                <LoginFooter buildNumber={buildNumber} />
            </div>
        </div>
    );

};
